function validateZipCode(e) {
   const zipcode = document.getElementById('zipcode').value;

   if (typeof window.Zapiet === 'undefined' || typeof window.ZapietCachedSettings === 'undefined' || 
       typeof window.Zapiet.DeliveryValidator === 'undefined' || window.ZapietCachedSettings.cached_config === 'undefined' || 
       window.ZapietCachedSettings.cached_config.delivery_validator === 'undefined') {
     console.warn('Zapiet - Custom delivery validator error. Please ensure you have Store Pickup + Delivery correctly installed.');
     return false;
   }

   Zapiet.DeliveryValidator.checkEligiblity(zipcode, function(response) {
      Zapiet.DeliveryValidator.eligibleForDelivery(response);
   }, function() {
      Zapiet.DeliveryValidator.notEligibleForDelivery();
   }, function() {
      Zapiet.DeliveryValidator.error();
   });

   return false;
}